import { createSlice } from "@reduxjs/toolkit";
import { fetchRolesData, createRole, updateRole, deleteRole } from "../Thunks/rolesThunk";
import { normalizeRolesListResponse, normalizeRoleItemResponse } from "../mappers/rolesMappers";
import {
  addAsyncResourceThunk,
  completeResourceSuccess,
  applyResourceRejected,
} from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    clearRoles: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchRolesData, {
      onFulfilled: (state, action) => {
        state.data = normalizeRolesListResponse(action.payload);
      },
    });
    builder
      .addCase(createRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        completeResourceSuccess(state);
        const role = normalizeRoleItemResponse(action.payload);
        if (state.data?.list) {
          state.data.list.push(role);
          state.data.totalCount = state.data.list.length;
        }
      })
      .addCase(createRole.rejected, (state, action) => {
        applyResourceRejected(state, action, "Failed to create role");
      })
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        completeResourceSuccess(state);
        const role = normalizeRoleItemResponse(action.payload);
        if (state.data?.list) {
          const index = state.data.list.findIndex((r) => r.id === role.id);
          if (index !== -1) {
            state.data.list[index] = role;
          }
        }
      })
      .addCase(updateRole.rejected, (state, action) => {
        applyResourceRejected(state, action, "Failed to update role");
      })
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        completeResourceSuccess(state);
        if (state.data?.list) {
          state.data.list = state.data.list.filter((r) => r.id !== action.payload);
          state.data.totalCount = state.data.list.length;
        }
      })
      .addCase(deleteRole.rejected, (state, action) => {
        applyResourceRejected(state, action, "Failed to delete role");
      });
  },
});

export const { clearRoles } = rolesSlice.actions;

// Selectors
export const selectRolesData = (state) => state.roles.data;
export const selectRolesList = (state) => state.roles.data?.list || [];
export const selectRolesLoading = (state) => state.roles.loading;
export const selectRolesError = (state) => state.roles.error;

export default rolesSlice.reducer;
